import {SET_MOBILE_BOTTOM_SPACER} from '../actions/actionsTypes';

const mobileBottomSpacer = (state=null, action) => {
  if(action.type === SET_MOBILE_BOTTOM_SPACER){
    return action.value
  }
  return state
}

export default mobileBottomSpacer